import React, { useEffect } from 'react';

import { useAnalyticsEvents } from '@atlaskit/teams-app-internal-analytics';

import { CardError } from './CardError';

export function CardErrorState({
	testId,
	errorType,
}: {
	testId: string;
	errorType: string;
}): React.JSX.Element {
	const { fireEvent } = useAnalyticsEvents();
	useEffect(() => {
		fireEvent('ui.userProfileCard.rendered.error', { errorType });
	}, [fireEvent, errorType]);
	return <CardError testId={testId} />;
}
